import { render, staticRenderFns } from "./my-booking.vue?vue&type=template&id=c12f5330&scoped=true"
import script from "./my-booking.vue?vue&type=script&lang=js"
export * from "./my-booking.vue?vue&type=script&lang=js"
import style0 from "./my-booking.vue?vue&type=style&index=0&id=c12f5330&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12f5330",
  null
  
)

export default component.exports